import { useState, useEffect } from 'react'
import { buscarNoticiasPorTime, buscarNoticiasNFL } from '../lib/espn'

// Cache simples em memória para evitar requests repetidos
const cache = {}
const CACHE_TTL = 5 * 60 * 1000 // 5 minutos

export function useNoticias(teamAbbr = null) {
  const [noticias, setNoticias] = useState([])
  const [loading, setLoading] = useState(true)
  const [erro, setErro] = useState(null)

  useEffect(() => {
    async function carregar() {
      setLoading(true)
      setErro(null)

      const cacheKey = teamAbbr || 'geral'
      const agora = Date.now()

      // Usa cache se ainda válido
      if (cache[cacheKey] && agora - cache[cacheKey].timestamp < CACHE_TTL) {
        setNoticias(cache[cacheKey].data)
        setLoading(false)
        return
      }

      const resultado = teamAbbr
        ? await buscarNoticiasPorTime(teamAbbr)
        : await buscarNoticiasNFL(20)

      if (resultado.sucesso) {
        cache[cacheKey] = { data: resultado.noticias, timestamp: agora }
        setNoticias(resultado.noticias)
      } else {
        setErro('Não foi possível carregar as notícias.')
      }

      setLoading(false)
    }

    carregar()
  }, [teamAbbr])

  return { noticias, loading, erro }
}
